import { useTranslation } from "react-i18next";

import React, { useState } from "react";
import { StyledBuilderContainer } from "../../components/MattressBuilder/MattressBuilderContainer";
import BigBackgroundText from "../../components/TextComponents/BigBackgroundText";
import mattress_photo from "../../assets/images/mattress/Layer 0.png";

import { MattressBuilderProvider } from "./BedSizeSelector/MattressBuilderContext";
import MattressBuilderWizard from "./MattressBuilderWizard";
import MattressBuilderWrapper from "./MattressBuilderWrapper";

import styled from "styled-components";

const MattressBuilder = () => {
  const { t } = useTranslation();

  return (
    <div className="row">
      <MattressBuilderProvider>
        <MattressBuilderWrapper />
      </MattressBuilderProvider>
    </div>
  );
};

export default MattressBuilder;
